module.exports = __webpack_public_path__ + "img/maintenance.48b3ee62.png";